import { ChevronLeft } from "@mui/icons-material/";
import { Box, IconButton, Paper, Typography } from "@mui/material";
import { GetData } from "contexts/DataContext";
import { isObjectEmpty } from "data/functions";
import * as React from "react";
import { useNavigate } from "react-router-dom";

export const PageTitle = (props) => {
  const navigate = useNavigate();
  const { dataObj } = GetData();

  return (
    <React.Fragment>
      <Box sx={{ background: "transparent", height: "12px" }}></Box>
      <Paper
        sx={{
          boxShadow: "none",
          display: props.display ? props.display : undefined,
          // minHeight: "50px",
          padding: dataObj?.deviceWidth?.isMobile ? "6px 0" : undefined,
          position: "relative",
        }}
      >
        <IconButton
          // color={"w"}
          disableRipple
          onClick={() => {
            props?.home ? navigate("/") : navigate(-1);
          }}
          sx={{
            bottom: 0,
            padding: 0,
            position: "absolute",
            top: 0,
            width: dataObj?.deviceWidth?.isMobile ? "60px" : "40px",
          }}
          variant="outlined"
        >
          <ChevronLeft sx={{ height: "1.2em", opacity: 1, width: "1.2em" }} />
        </IconButton>

        <Box
          sx={{
            alignContent: "center",
            // flexWrap: "wrap",
            alignItems:
              dataObj?.deviceWidth?.isMobile && !props?.alignStart
                ? "center"
                : "flex-start",
            display: "flex",
            flexDirection: dataObj?.deviceWidth?.isMobile ? "column" : "row",
            gridGap: !dataObj?.deviceWidth?.isMobile ? "12px" : undefined,
            justifyContent: dataObj?.deviceWidth?.isMobile
              ? "center"
              : "flex-start",
            minHeight: "inherit",
            padding:
              dataObj?.deviceWidth?.isMobile && props?.alignStart
                ? "0.4rem 3rem"
                : dataObj?.deviceWidth?.isMobile
                ? "0"
                : "1rem 3rem",
          }}
        >
          <Typography
            sx={{
              textAlign: dataObj?.deviceWidth?.isMobile ? "center" : "start",
            }}
            variant={dataObj?.deviceWidth?.isMobile ? "h5" : "h4"}
          >
            {!isObjectEmpty(props.title) ? props.title : ""}
          </Typography>
          <Typography
            sx={{
              textAlign: "center",
            }}
            variant={dataObj?.deviceWidth?.isMobile ? "h5" : "h4"}
          >
            {!isObjectEmpty(props.title2) ? props.title2 : ""}
          </Typography>
        </Box>
      </Paper>
    </React.Fragment>
  );
};
